<template>
  <div class="app-shell grey lighten-4"> <!-- blue-grey lighten-5 grey lighten-5 blue-grey lighten-5 -->
    <Header />
    <main>
      <router-view />
    </main>
    <div class="app-update-toast" v-if="updateReady">
      <span>A new EasyHMO version is ready.</span>
      <button type="button" @click="reloadApp">Update</button>
    </div>
    <!-- <Footer /> -->
    <div class="app-bottom-spacer" aria-hidden="true"></div>
  </div>
</template>


<script>
import { onMounted, onUnmounted, ref } from "vue";
import Header from "@/components/HeaderDiv.vue";
// import Footer from "@/components/FooterDiv.vue";

export default {
  name: "App",
  components: { Header },
  setup() {
    const updateReady = ref(false);

    const showUpdate = () => {
      updateReady.value = true;
    };

    const reloadApp = () => {
      window.location.reload();
    };

    onMounted(() => {
      window.addEventListener("easyhmo-app-update-ready", showUpdate);
    });

    onUnmounted(() => {
      window.removeEventListener("easyhmo-app-update-ready", showUpdate);
    });

    return {
      updateReady,
      reloadApp,
    };
  },
};
</script>

<style>
html,
body {
  max-width: 100%;
  overflow-x: hidden;
}

.app-shell {
  min-height: 100vh;
  background: #fafafa;
  background-color: #fafafa;
  overflow-x: hidden;
}

.app-shell.grey.lighten-4 {
  background: #fafafa !important;
  background-color: #fafafa !important;
}

.app-shell main {
  min-height: calc(100vh - 64px);
  padding-bottom: 24px;
}

.app-bottom-spacer {
  height: 64px;
}

.app-update-toast {
  align-items: center;
  background: #263238;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  bottom: 18px;
  box-shadow: 0 18px 36px -24px rgba(38, 50, 56, 0.8);
  color: #ffffff;
  display: flex;
  gap: 14px;
  left: 50%;
  max-width: calc(100vw - 32px);
  padding: 12px 14px 12px 16px;
  position: fixed;
  transform: translateX(-50%);
  z-index: 2000;
}

.app-update-toast span {
  font-size: 0.9rem;
  font-weight: 700;
  white-space: nowrap;
}

.app-update-toast button {
  background: #80cbc4;
  border: 0;
  border-radius: 4px;
  color: #003c35;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 900;
  padding: 7px 12px;
  text-transform: uppercase;
}

.sba-collection-breadcrumb {
  background: #fafafa !important;
  background-color: #fafafa !important;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  height: auto;
  line-height: normal;
  padding: 6px 0 22px;
  position: relative;
}

.sba-collection-breadcrumb.grey.lighten-4 {
  background: #fafafa !important;
  background-color: #fafafa !important;
}

.sba-collection-breadcrumb::after {
  background: #c4d3d9;
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.sba-collection-breadcrumb .nav-wrapper {
  align-items: center;
  display: flex;
  height: auto;
  justify-content: space-between;
  line-height: normal;
  min-height: 32px;
  overflow: hidden;
}

.sba-collection-breadcrumb-row {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow: hidden;
  min-width: 0;
  width: 100%;
  min-height: 28px;
  padding-bottom: 4px;
}

.sba-collection-breadcrumb .sba-collection-crumb {
  align-items: center;
  display: inline-flex;
  flex: 0 1 auto;
  font-size: 0.84rem !important;
  font-weight: 500;
  gap: 8px;
  line-height: 28px;
  min-height: 28px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sba-collection-breadcrumb .breadcrumb.sba-collection-crumb::before {
  content: none !important;
  display: none !important;
}

.sba-collection-breadcrumb .sba-collection-crumb {
  color: #607d8b !important;
  font-weight: 600;
}

.sba-collection-breadcrumb a.sba-collection-crumb {
  color: #00897b !important;
  cursor: pointer;
  transition: color 0.18s ease;
}

.sba-collection-breadcrumb a.sba-collection-crumb:hover {
  color: #00796b !important;
}

.sba-collection-breadcrumb-row > .sba-collection-crumb:first-child::after {
  content: none;
  display: none;
}

.sba-collection-breadcrumb .sba-collection-crumb i {
  float: none;
  font-size: 19px;
  height: 19px;
  line-height: 19px;
  margin: 0;
}

.sba-collection-breadcrumb .sba-collection-crumb span {
  font-size: inherit;
  line-height: 28px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sba-collection-crumb-separator {
  color: rgba(96, 125, 139, 0.34);
  font-size: 17px;
  height: 17px;
  line-height: 17px;
}

.sba-collection-context {
  box-sizing: border-box;
  color: #546e7a;
  display: block;
  flex: 0 1 220px;
  font-size: 0.84rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-left: auto;
  max-width: 28%;
  min-width: 0;
  overflow: hidden;
  padding-left: 10px;
  padding-right: 8px;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media only screen and (max-width: 992px) {
  .sba-collection-context {
    display: none;
  }
}

.sba-collection-page-surface {
  min-height: calc(100vh - 188px);
  padding: 0 0 48px;
  position: relative;
}

.sba-collection-page-surface > .container {
  animation: sbaSurfaceRise 420ms ease-out both;
  margin-top: -18px;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.sba-collection-page-surface.sba-no-surface-rise > .container {
  animation: none;
}

.sba-collection-page-surface.is-workbench > .container {
  margin-top: -12px;
  padding-top: 0;
}

.sba-slide-in {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.sba-slide-in-children > * {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.sba-open-frame {
  margin-bottom: 0;
}

.sba-open-frame-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.sba-open-workbench {
  width: 100%;
}

.sba-open-head {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  overflow: visible;
  padding: 28px 34px;
  position: relative;
  z-index: 2;
}

.sba-open-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.sba-open-head > * {
  position: relative;
  z-index: 2;
}

.sba-open-title label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.sba-open-title h5 {
  color: #263238;
  font-size: 1.65rem;
  font-weight: 700;
  margin: 0 0 10px;
}

.sba-open-title p {
  color: #607d8b;
  font-size: 1rem;
  line-height: 1.55;
  margin: 0;
}

.sba-open-count {
  background: #f5f5f5;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #263238;
  display: inline-flex;
  flex-direction: column;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.1;
  min-width: 96px;
  padding: 12px 14px;
  text-align: center;
}

.sba-open-count small {
  color: #607d8b;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 3px;
}

.sba-open-switch {
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 16px;
  padding: 5px;
}

.sba-open-switch button,
.sba-open-switch span {
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #607d8b;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  min-height: 34px;
  padding: 8px 14px;
}

.sba-open-switch .is-active,
.sba-open-switch .tab-custom-active {
  background: #263238 !important;
  color: #ffffff !important;
}

.sba-open-list-head {
  background: rgba(255, 255, 255, 0.72) !important;
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 12px;
  padding: 13px 20px;
  text-transform: uppercase;
}

.sba-open-row {
  background: linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%) !important;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none !important;
  margin-bottom: 12px;
  padding: 22px;
}

.sba-open-row.is-open {
  box-shadow: 0 8px 22px rgba(38, 50, 56, 0.08) !important;
}

.sba-open-action {
  align-items: center;
  background: #00838f;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;
}

.sba-open-action.is-close {
  background: #263238;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .app-shell main {
    min-height: calc(100vh - 64px);
    padding-bottom: 20px;
  }

  .app-shell .container {
    width: 92%;
  }

  .sba-collection-breadcrumb {
    padding: 8px 0 18px;
  }

  .sba-collection-breadcrumb-row {
    gap: 9px;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }

  .sba-collection-breadcrumb-row::-webkit-scrollbar {
    display: none;
  }

  .sba-collection-breadcrumb .sba-collection-crumb {
    flex: 0 0 auto;
    max-width: 38vw;
  }

  .sba-collection-context {
    margin-left: auto;
    max-width: 34vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sba-collection-page-surface {
    padding-bottom: 38px;
  }

  .sba-collection-page-surface > .container {
    margin-top: -14px;
    width: 92%;
  }

  .sba-open-head {
    gap: 16px;
    padding: 22px 24px;
  }

  .sba-open-row {
    padding: 18px;
  }

  .sba-open-list-head {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .app-shell main {
    min-height: calc(100vh - 56px);
    padding-bottom: 18px;
  }

  .app-bottom-spacer {
    height: 42px;
  }

  .app-update-toast {
    align-items: stretch;
    bottom: 12px;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    width: calc(100vw - 24px);
  }

  .app-update-toast span {
    line-height: 1.35;
    white-space: normal;
  }

  .app-update-toast button {
    min-height: 40px;
    width: 100%;
  }

  .app-shell .container {
    width: calc(100% - 24px);
  }

  .sba-collection-breadcrumb {
    padding: 5px 0 16px;
  }

  .sba-collection-breadcrumb .nav-wrapper {
    min-height: 30px;
  }

  .sba-collection-breadcrumb-row {
    gap: 6px;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }

  .sba-collection-breadcrumb-row::-webkit-scrollbar {
    display: none;
  }

  .sba-collection-breadcrumb .sba-collection-crumb {
    flex: 0 0 auto;
    font-size: 0.78rem !important;
    gap: 5px;
    max-width: 46vw;
  }

  .sba-collection-breadcrumb .sba-collection-crumb i {
    font-size: 18px;
    height: 18px;
    line-height: 18px;
  }

  .sba-collection-crumb-separator {
    flex: 0 0 auto;
    font-size: 15px;
  }

  .sba-collection-page-surface {
    padding-bottom: 34px;
  }

  .sba-collection-page-surface > .container {
    margin-top: -12px;
  }

  .sba-open-head {
    align-items: flex-start;
    flex-direction: column;
    padding: 22px;
  }

  .sba-open-count {
    margin-top: 16px;
    text-align: left;
  }

  .sba-open-row {
    padding: 16px;
  }
}

@keyframes sbaSurfaceRise {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes sbaSlideIn {
  from {
    opacity: var(--sba-slide-from-opacity, 0.88);
    transform: translateY(var(--sba-slide-distance, 6px));
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .sba-collection-page-surface > .container,
  .sba-slide-in,
  .sba-slide-in-children > * {
    animation: none;
  }
}
</style>
